/**
 * The desktop first-run window (account, email recovery, setup review) and the
 * browser welcome cards. Shared sign-in words (Email, Password, Sign in, the
 * terms line) live in `auth`.
 */
export default {
  welcomeBack: "Welcome back.",
  pickUpWhereYouLeftOff: "Pick up where you left off.",
  reviewSetup: "Review setup",
  connectingAccount: "Connecting your account…",
  checkYourEmail: "Check your email.",
  welcomeToDenker: "Welcome to Denker.",
  registerIntro: "Works in your apps, on the agents you already pay for.",
  accountTabs: "Account",
  completeInBrowser:
    "Complete sign-in in your browser. We’ll bring you back here.",
  forgotPassword: "Forgot password?",
  continueWithGoogle: "Continue with Google",
  passwordUpdated: "Password updated. Sign in to continue.",

  chooseNewPassword: "Choose a new password.",
  newPasswordIntro: "Update your password, then sign in to continue.",
  newPassword: "New password",
  confirmPassword: "Confirm password",
  updating: "Updating…",
  updatePassword: "Update password",
  backToSignIn: "Back to sign in",

  forgotYourPassword: "Forgot your password?",
  resetIntro: "We’ll send you a link to reset it.",
  resetSentIntro:
    "If an account uses this email, you’ll receive a password reset link.",
  resetSentStatus:
    "Open the email link, then choose your new password here in Denker.",
  sendResetLink: "Send reset link",

  verificationIntro:
    "Follow the verification link in your email, then return to Denker. You won’t need to enter your password again for this sign-in attempt.",
  checkVerification: "Check verification",
  resendEmail: "Resend email",
  working: "Working…",
  resendNotice: "If verification is needed, check your inbox for a new link.",

  openingSetup: "Opening setup…",
  reviewFailed: "Setup could not restart. Your account is still signed in.",
  setupDialog: "Denker setup",
  moveSetupWindow: "Move setup window",
  openingYourGuide: "Opening your guide",
  makeYourselfAtHome: "Make yourself at home.",
  openingYourGuideProgress: "Opening your guide…",

  webWelcomeTitle: "Welcome to Denker",
  webWelcomeAsk: "Your AI coworker. What should we call you?",
  yourName: "Your name",
  skipSetup: "Skip setup",
  allSet: "You're all set",
  readyToGo: "Denker is ready to go.",
  getStarted: "Get started",
} as const;
